import { useState } from 'react'
import { toast } from 'sonner'
import { createFileRoute } from '@tanstack/react-router'

import { fileUploadToast } from '@/components/molecules/custom-async-toasts'
import { Button } from '@/components/ui/button'
import { getDocumentIcon, getTimelineEventIcon } from '@/utils/icon.utils'

import { Document } from '@backend/payload/payload-types'

export const Route = createFileRoute('/_authenticated/(developer)/design-system')({
  component: DesignSystemPage,
})

function DesignSystemPage() {
  const documentTypes: Document['type'][] = [
    'certificate',
    'decision',
    'diagnosis',
    'prescription',
    'document',
    'application',
    'report',
    'unknown',
  ]

  const timelineEventTypes = [
    'certificate',
    'report',
    'application',
    'birth',
    'birthday',
    'decision',
    'diagnosis',
    'prescription',
    'document',
    'life-event',
    'unknown',
  ] as const

  const testing = (
    <div className="flex gap-2 flex-wrap my-4">
      <div className="size-[100px] border-2 bg-brand-soft border-brand-subtle text-brand-fg-strong flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] border-2 bg-success-soft border-success-subtle text-success-fg-strong flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] border-2 bg-success-bg border-success-border text-success  flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] hover:bg-success-solid-hover bg-success-solid text-success-solid-fg flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] border-2 bg-info-bg border-info-border text-info  flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] hover:bg-info-solid-hover bg-info-solid text-info-solid-fg flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] border-2 bg-warning-bg border-warning-border text-warning  flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] hover:bg-warning-solid-hover bg-warning-solid text-warning-solid-fg flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] border-2 bg-error-bg border-error-border text-error  flex items-center justify-center rounded">
        Text
      </div>
      <div className="size-[100px] hover:bg-error-solid-hover bg-error-solid text-error-solid-fg flex items-center justify-center rounded">
        Text
      </div>
      <div className="flex-col size-[200px] bg-layer-0 hover:bg-layer-1 text-primary border hover:border-subtle-02 flex items-center justify-center rounded">
        <p className="text-text-primary">Primary</p>
        <p className="text-text-secondary">Secondary</p>
        <p className="text-text-helper">Helper</p>
      </div>
    </div>
  )

  const [isAsyncButtonLoading, setIsAsyncButtonLoading] = useState(false)

  return (
    <div>
      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4">Document Types</h2>
        <div className="flex flex-wrap gap-4 mb-8">
          {documentTypes.map(type => {
            const Icon = getDocumentIcon(type)

            return (
              <div
                className="flex flex-col items-center gap-2 p-4 border rounded-lg bg-layer-1 min-w-[120px]"
                key={type}
              >
                <Icon className="size-8" />
                <span className="text-sm font-medium capitalize">{type}</span>
              </div>
            )
          })}
        </div>

        <h2 className="text-2xl font-bold mb-4">Timeline Event Types</h2>
        <div className="flex flex-wrap gap-4 mb-8">
          {timelineEventTypes.map(type => {
            const Icon = getTimelineEventIcon(type)

            return (
              <div
                className="flex flex-col items-center gap-2 p-4 border rounded-lg bg-layer-1 min-w-[120px]"
                key={type}
              >
                <Icon className="size-8" />
                <span className="text-sm font-medium capitalize">{type}</span>
              </div>
            )
          })}
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-4">Buttons & Toasts</h2>
      <div className="mb-10 flex flex-wrap gap-4">
        <div className="bg-layer-1 flex p-4 flex-wrap gap-4 rounded border border-layer-1">
          <Button variant="default">Button Primary</Button>
          <Button variant="neutral">Button Neutral</Button>
          <Button variant="background">Button Background</Button>
          <Button variant="outline">Button Outline</Button>
          <Button variant="ghost">Button Ghost</Button>
        </div>
        <Button
          isLoading={isAsyncButtonLoading}
          onClick={async () => {
            setIsAsyncButtonLoading(true)
            await new Promise(res => setTimeout(res, 2000))
            setIsAsyncButtonLoading(false)
          }}
        >
          Async Button
        </Button>
        <Button onClick={() => toast.success('Success toast!')}>Toast Success</Button>
        <Button onClick={() => toast.error('Error toast!')}>Toast Error</Button>
        <Button onClick={() => toast.warning('Warning toast!')}>Toast Warning</Button>
        <Button onClick={() => toast.info('Info toast!')}>Toast Info</Button>
        <Button onClick={() => toast('Default toast!')}>Toast Default</Button>
        <Button onClick={() => fileUploadToast(new Promise(res => setTimeout(res, 2000)))}>
          Toast Upload (success)
        </Button>
        <Button onClick={() => fileUploadToast(new Promise((_, rej) => setTimeout(rej, 2000)))}>
          Toast Upload (fail)
        </Button>
      </div>
      {testing}
      <div className="dark bg-black p-2 px-4 mt-2">{testing}</div>
    </div>
  )
}
